import { render, staticRenderFns } from "./OurAgents.vue?vue&type=template&id=f5b861ba&scoped=true&"
import script from "./OurAgents.vue?vue&type=script&lang=ts&"
export * from "./OurAgents.vue?vue&type=script&lang=ts&"
import style0 from "./OurAgents.vue?vue&type=style&index=0&id=f5b861ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b861ba",
  null
  
)

export default component.exports